import Head from "next/head";
import Link from "next/link";


export default function Trailer() {
	return (
		<>
			<Head>
				<title key="title">View Trailer | Lucien Smith - Seeds</title>
			</Head>
			<div className="mt-6 max-w-full">
				<h1 className="text-4xl text-center">
					<Link href="/">
						<a className="bland special-underline">SEEDS</a>
					</Link>
				</h1>
				<h1 className="text-xl text-center mt-14">Trailer</h1>
				<div className="text-lg leading-7 mt-5">
					<video width="300" height="225" poster="https://storage.googleapis.com/seeds-artificats/trailer_poster.png" controls>
						<source src="https://storage.googleapis.com/seeds-artificats/seeds.mp4" type="video/mp4" />
					</video>
				</div>
			</div>
		</>
	);
}
